module.exports = __webpack_public_path__ + "static/visie-2-e3ba91251d1e1320b5c5e6917e2dd12f.jpg";